import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from 'src/app/shared/config';
import { RunService } from 'src/app/shared/services';

@Component({
  selector: 'app-out',
  templateUrl: './out.component.html',
  styleUrls: ['./out.component.styl']
})
export class RedOutComponent implements OnInit {
  deviceMode = null;

  data: {label: string, subs: any[]}[] = [];

  constructor(
    private router: Router,
    private runService: RunService
  ) { }

  ngOnInit() {
    this.data = ROUTES[1].data[2].subs;
  }

  toTuoYu(url: string) {
    this.runService.reBackUrl = '/red/out';
    this.router.navigateByUrl(url);
  }
}
